import React, { useEffect, useRef, useState } from "react";
import { Volume2, Square, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { logger } from "../lib/logger";
import { useVoiceStatus } from "../lib/useVoiceStatus";

let activeAudio = null;

export default function ListenButton({ sessionId, text, label = "Listen", testId = "listen-btn", className = "" }) {
    const { tts } = useVoiceStatus();
    const [state, setState] = useState("idle");
    const audioRef = useRef(null);

    useEffect(() => () => { audioRef.current?.pause(); if (activeAudio === audioRef.current) activeAudio = null; }, []);

    if (!tts || !text) return null;

    const stop = () => {
        audioRef.current?.pause();
        setState("idle");
    };

    const play = async () => {
        activeAudio?.pause();
        setState("loading");
        try {
            const blob = await api.tts(sessionId, text);
            const url = URL.createObjectURL(blob);
            const audio = new Audio(url);
            audioRef.current = audio;
            activeAudio = audio;
            audio.onended = () => { setState("idle"); URL.revokeObjectURL(url); };
            audio.onpause = () => setState("idle");
            await audio.play();
            setState("playing");
        } catch (err) {
            logger.warn("tts playback failed:", err);
            toast.error("Couldn't play narration right now.");
            setState("idle");
        }
    };

    const playing = state === "playing";
    const loading = state === "loading";
    return (
        <button
            type="button"
            data-testid={testId}
            onClick={playing ? stop : play}
            disabled={loading}
            aria-label={playing ? "Stop narration" : label}
            className={`tap-target inline-flex items-center gap-1.5 text-[10px] tracking-[0.24em] uppercase text-burgundy/80 hover:text-burgundy disabled:opacity-50 ${className}`}
        >
            {loading ? <Loader2 size={14} className="animate-spin" /> : playing ? <Square size={12} /> : <Volume2 size={14} />}
            {playing ? "Stop" : loading ? "Loading" : label}
        </button>
    );
}
